/**
 * 该js文件专门存放各类通用的服务端API调用方法
 * @author luwei
 */

import { post } from '@/util/http'

/**
 * 根据字典类型名称列表获取字典项
 *
 * @param params
 *            字典类型名称列表，例如
 *            例如: { lsStrings: ['apply-platform-type', 'sex'] }
 * @return Result 结果对象
 */
export const getDictItemsByTypeNames = params => post(`/dict/item/getDictItemsByTypeNames`, params)
